export default __webpack_public_path__ + "static/media/agreement2.9945685a.txt";